import { useContext } from 'react';
import { Form, Input, Button, Message, Header } from 'semantic-ui-react';
import { store } from '../store';
import {
  UPDATE_BORDER,
  UPDATE_FIT_IMAGE,
  UPDATE_GRID_SIZE,
  UPDATE_PAPER_HEIGHT,
  UPDATE_PAPER_WIDTH,
  UPDATE_GRID_COLOR,
  UPDATE_GRID,
  UPDATE_GRID_SECOND,
  UPDATE_GRID_COLOR_SECOND,
  UPDATE_GRID_SIZE_SECOND,
  SET_SHOW_GRID_LABELS,
} from '../types';
import ImageUploadButton from './ImageUploadButton';

const Controls = () => {
  const {
    paperWidth,
    paperHeight,
    border,
    grid,
    gridSecond,
    gridSize,
    gridSizeSecond,
    gridColor,
    gridColorSecond,
    showGridLabels,
    stretchImage,
    dispatch,
  } = useContext(store);
  const setWidth = (width) =>
    dispatch({ type: UPDATE_PAPER_WIDTH, payload: width });
  const setHeight = (height) =>
    dispatch({ type: UPDATE_PAPER_HEIGHT, payload: height });
  const setBorder = (size) => dispatch({ type: UPDATE_BORDER, payload: size });
  const setStretchImage = (on) =>
    dispatch({ type: UPDATE_FIT_IMAGE, payload: on });
  const setGrid = () => dispatch({ type: UPDATE_GRID, payload: !grid });
  const setGridLabels = () =>
    dispatch({ type: SET_SHOW_GRID_LABELS, payload: !showGridLabels });
  const setGridSize = (size) =>
    dispatch({ type: UPDATE_GRID_SIZE, payload: size });
  const setGridColor = (color) =>
    dispatch({ type: UPDATE_GRID_COLOR, payload: color });
  const setGridSecond = () =>
    dispatch({ type: UPDATE_GRID_SECOND, payload: !gridSecond });
  const setGridSizeSecond = (size) =>
    dispatch({ type: UPDATE_GRID_SIZE_SECOND, payload: size });
  const setGridColorSecond = (color) =>
    dispatch({ type: UPDATE_GRID_COLOR_SECOND, payload: color });

  const swapWidthHeight = () => {
    dispatch({ type: UPDATE_PAPER_WIDTH, payload: paperHeight });
    dispatch({ type: UPDATE_PAPER_HEIGHT, payload: paperWidth });
  };

  const cols = paperWidth / gridSize;
  const rows = paperHeight / gridSize;
  const cols2 = paperWidth / gridSizeSecond;
  const rows2 = paperHeight / gridSizeSecond;
  const validColsRows = Number.isInteger(cols) && Number.isInteger(rows);
  const validColsRows2 = Number.isInteger(cols2) && Number.isInteger(rows2);
  const colorOptions = [
    { key: 'black', text: 'Black', value: '#000' },
    { key: 'white', text: 'White', value: '#FFF' },
    { key: 'blue', text: 'Blue', value: '#799EC4' },
    { key: 'red', text: 'Red', value: '#F1473C' },
    { key: 'yellow', text: 'Yellow', value: '#D7D360' },
    { key: 'green', text: 'Green', value: '#0D9671' },
    { key: 'purple', text: 'Purple', value: '#A346B8' },
  ];

  return (
    <Form error={!validColsRows || !validColsRows2}>
      <Header as="h2">Setup</Header>
      <Header as="h3">Paper Dimensions</Header>
      <Form.Group>
        <Form.Field
          id="form-input-control-width"
          control={Input}
          label="Paper Width"
          placeholder="Width"
          type="number"
          value={paperWidth}
          min={0}
          width={3}
          onChange={({ target }) => setWidth(target.value)}
        />
        <Button
          icon="exchange"
          onClick={swapWidthHeight}
          style={{ height: 'max-content', alignSelf: 'flex-end', margin: 0 }}
        />
        <Form.Field
          id="form-input-control-height"
          control={Input}
          label="Paper Height"
          placeholder="Height"
          type="number"
          value={paperHeight}
          min={0}
          width={3}
          onChange={({ target }) => setHeight(target.value)}
        />
        <Form.Field
          id="form-input-control-border"
          control={Input}
          label="Border Thickness"
          placeholder="Border"
          type="number"
          value={border}
          min={0}
          step={0.25}
          width={3}
          onChange={({ target }) => setBorder(target.value)}
        />
      </Form.Group>
      <Header as="h3">Image</Header>
      <Form.Group>
        <ImageUploadButton />
        <Form.Checkbox
          toggle
          label="Stretch Image"
          checked={stretchImage}
          onChange={() => setStretchImage(!stretchImage)}
          style={{ marginTop: 7 }}
        />
      </Form.Group>
      <Header as="h3">Grid</Header>
      <Form.Group>
        <Form.Checkbox
          toggle
          label="Show Grid"
          checked={grid}
          onChange={setGrid}
        />
      </Form.Group>
      {grid && (
        <>
          <Form.Group>
            <Form.Field
              id="form-input-control-grid-size"
              control={Input}
              label="Grid Size"
              placeholder="Size"
              type="number"
              value={gridSize}
              min={0.5}
              step={0.5}
              width={3}
              error={!validColsRows}
              onChange={({ target }) => setGridSize(target.value)}
            />
            <Form.Select
              label="Grid Color"
              options={colorOptions}
              compact
              value={gridColor}
              onChange={(e, { value }) => setGridColor(value)}
            />
            <Form.Checkbox
              toggle
              label="Show Labels"
              checked={showGridLabels}
              onChange={setGridLabels}
              style={{ marginTop: 30 }}
            />
          </Form.Group>
          <Header as="h3">Second Grid</Header>
          <Form.Group>
            <Form.Checkbox
              toggle
              label="Show Grid"
              checked={gridSecond}
              onChange={setGridSecond}
            />
          </Form.Group>
          {gridSecond && (
            <Form.Group>
              <Form.Field
                id="form-input-control-grid-second-size"
                control={Input}
                label="Grid Size"
                placeholder="Size"
                type="number"
                value={gridSizeSecond}
                min={0.5}
                step={0.5}
                width={3}
                error={!validColsRows2}
                onChange={({ target }) => setGridSizeSecond(target.value)}
              />
              <Form.Select
                label="Grid Color"
                options={colorOptions}
                compact
                value={gridColorSecond}
                onChange={(e, { value }) => setGridColorSecond(value)}
              />
            </Form.Group>
          )}
        </>
      )}
      <Message
        error
        header="Invalid Grid Size"
        content="For the paper dimensions set, this grid size will not display correctly."
      />
    </Form>
  );
};

export default Controls;
